
  <div class="col-lg-12 nopadding">
    <app-filter-panel [GridColumns]="GridColumns" [DefaultFilterArray]="defaultFilterArray"
      (FilterEvent)="filterApplyFilterEvent($event)">
    </app-filter-panel>
  </div>
  <br/>
  <!-- Summary Table Details -->
    <div class="col-lg-12 nopadding">
      @if(isLoadingResults){
      <div class="example-loading-shade">
        <mat-spinner></mat-spinner>
      </div>}
      <p-table #dt 
        [value]="dataset" 
        [columns]="cols" 
        [resizableColumns]="true" 
        [lazy]="true" 
        (onPage)="changePage($event)"
        [sortOrder]="constantService.DEFAULT_SORDORDER_ASC" 
        [(selection)]="selectedRow"
        [paginator]="true"
        selectionMode="single"
        appendTo="body" 
        alwaysShowPaginator="true" 
        paginatorPosition="both"
        showCurrentPageReport="true" 
        [rows]="constantService.DEFAULT_ROWSIZE" 
        [totalRecords]="totalRecords"
        [pageLinks]="constantService.DEFAULT_PAGELINKS" 
        sortMode="multiple"
        (onSort)="sort($event)"
        [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION"
        [scrollable]="true" 
        scrollHeight="70vh"
        styleClass="tableData">
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{constantService.NO_RECORDFOUND_MSG}}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="header" let-columns let-rowIndex=rowIndex>
          <tr>
            @for(col of columns; track col.header + '-'+ $index;) {
            <th id="columnHeader" pResizableColumn [pSortableColumn]="col.field"
              [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
              {{col.header}}
              @if((col.header | lowercase) !== 'action'){
              <p-sortIcon [field]="col.field"></p-sortIcon>
              }
            </th>
          }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
          <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex" class="ui-widget-NoUpdated-row">
            @for(col of columns; track col.header + '-'+ $index;) {
            <td class="ui-resizable-column" 
            [ngClass]="col.header==='Action' ? 'text-center':''">
            @if(col.header==='Action' && (row.Text2.includes('Parameters: ') || row.Text2.length > 300)){
                <span>
                  <p-button matTooltip="View Parameters" [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body"
                      icon="fa fa-fw fa-eye" [id]="'dataRow'+ rowIndex" (click)="openViewer(row)">
                  </p-button>
                </span>
              }
              @if(col.header!=='Action'){
                <span>
                  {{row[col.field]}}
                </span>
              }
            </td>
          }
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorright">
            <app-export-to-csv [gridColumns]="GridColumns" (exportToCSVListner)="exportToCSV($event)"></app-export-to-csv>
          Total Records: {{dataset.length == 0? 0 : totalRecords}}

        </ng-template>
        <ng-template pTemplate="paginatorleft">
          <!-- Page No : {{pageNumber }} -->
          Showing {{dataset.length == 0? 0 : startLimit + 1}} to {{dataset.length
              < rowcount ? dataset.length < startLimit ? endLimit : dataset.length : endLimit}} entries
        </ng-template>
      </p-table>
    </div>
  <!-- End of Summary Table Details -->

<!-- Quick View Panel Code  -->
<p-drawer header="" id="activity-params-viewer" 
  [(visible)]="isDataViewer" 
  position="right" 
  [baseZIndex]="10000" 
  (onHide)="closeDialogbox()"
  [style]="{'width':'60%','max-width': '920px','height':'auto','overflow-y': 'auto','max-height':'100%','padding':'0px','margin':'0px'}"
  appendTo="body" styleClass="ui-sidebar-lg">
  <div class="ui-grid-col-12  nopadding container">

    @if(!hasJsonParameters){
    <mat-tab-group dynamicHeight>
      <mat-tab label="Log Detail">
        <div class="grid">
          <div class="col-6 nopadding container" style="float: left;">
            <h4 class="nopadding" style="color: black; font-size: 18px;"> Activity</h4>
            <pre [innerHTML]="(activity)"></pre>
          </div>
          <div class="col-6 nopadding container" style="float: left;">
            <h4 class="nopadding" style="color: black; font-size: 18px;"> Activity Parameters</h4>
            <pre [innerHTML]="(activityDetail)"></pre>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  }
  @if(hasJsonParameters){
    <mat-tab-group dynamicHeight>
      <mat-tab label="Beautify">
        <div class="grid">
          <div class="col-6 nopadding container" style="float: left;">
            <h4 class="nopadding" style="color: black; font-size: 18px;"> Activity</h4>
            <pre [innerHTML]="(activity)"></pre>
          </div>
          <div class="col-6 nopadding container" style="float: right;">
            <h4 class="nopadding" style="color: black; font-size: 18px;"> Activity Parameters</h4>
            <pre [innerHTML]="(activityDetail) | prettyjson : [false,3]"></pre>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Tree Viewer">
        <div class="grid">
          <div class="col-6 nopadding container" style="float: left;">
            <h4 class="nopadding" style="color: black; font-size: 18px;"> Activity</h4>
            <pre><app-json-formatter [data]="(activity)"></app-json-formatter></pre>
          </div>
          <div class="col-6 nopadding container" style="float: right;">
            <h4 class="nopadding" style="color: black; font-size: 18px;"> Activity Parameters</h4>
            <pre><app-json-formatter [data]="(activityDetail)" [openJsonObjTreeLevel]="2"></app-json-formatter></pre>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  }
  </div>
</p-drawer>